module.exports = __webpack_public_path__ + "static/media/logoutbtn.cd766f1c.png";